














import { defineComponent } from '@vue/composition-api'
import { useGetters } from 'vuex-composition-helpers'

import PageEditModeComponent from './PageEditMode.vue'
import MessageComponent from '@/shared/components/Message.vue'
import ErrorMessagesComponent from '@/shared/components/ErrorMessages.vue'

export default defineComponent({
    name: 'PageListEditModeComponent',
    components: {
        MessageComponent,
        ErrorMessagesComponent,
        PageEditModeComponent
    },
    setup() {
        const { getConfig, getError, getFavoritePagesByDate } = useGetters([
            'getConfig',
            'getError',
            'getFavoritePagesByDate'
        ])

        return {
            getConfig,
            getError,
            getFavoritePagesByDate
        }
    }
})
